var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXidenLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 259.138,
    height: 43.577,
    viewBox: "0 0 259.138 43.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ca0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7a1dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1.055,
    x2: 0.5,
    y2: -0.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ca0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2794ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#0b55ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#003dff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19444",
    "data-name": "Rectangle 19444",
    width: 5.398,
    height: 5.835
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kraterpool-by-xiden",
    transform: "translate(-386.995 -746.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11075",
    "data-name": "Group 11075",
    transform: "translate(386.995 746.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000156582744227697438140000016000809199894819979_",
    transform: "translate(0 0)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75178",
    "data-name": "Path 75178",
    d: "M399.6,752.71v25.2a6.3,6.3,0,1,1-12.6,0v-25.2a6.3,6.3,0,0,1,12.6,0Z",
    transform: "translate(-387 -746.41)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000150782099721560068420000014782453205710755718_",
    transform: "translate(0 0)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75179",
    "data-name": "Path 75179",
    d: "M397.75,748.251l25.2,25.2a6.3,6.3,0,1,1-8.91,8.91l-25.2-25.2a6.3,6.3,0,0,1,8.91-8.91Z",
    transform: "translate(-386.995 -746.405)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_00000050643809944539399360000015925732680398145452_",
    transform: "translate(12.6 0)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75180",
    "data-name": "Path 75180",
    d: "M798.45,769.761l4.455,4.455,17.056-17.056a6.3,6.3,0,0,0-8.91-8.91l-12.6,12.6A6.3,6.3,0,0,0,798.45,769.761Z",
    transform: "translate(-796.605 -746.405)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_00000154396928503572283180000002037950182532812424_",
    transform: "translate(25.201 25.201)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1935",
    "data-name": "Ellipse 1935",
    cx: 6.3,
    cy: 6.3,
    r: 6.3,
    fill: "#003dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_00000152236979223060798620000007058957812491027843_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1936",
    "data-name": "Ellipse 1936",
    cx: 6.3,
    cy: 6.3,
    r: 6.3,
    fill: "#7a1dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_00000098213958247576616980000013921881037691228041_",
    transform: "translate(0 25.201)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1937",
    "data-name": "Ellipse 1937",
    cx: 6.3,
    cy: 6.3,
    r: 6.3,
    fill: "#7a1dff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11081",
    "data-name": "Group 11081",
    transform: "translate(430.739 752.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11078",
    "data-name": "Group 11078",
    transform: "translate(176.1 30.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11076",
    "data-name": "Group 11076",
    transform: "translate(0 1.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75181",
    "data-name": "Path 75181",
    d: "M7533.578,1986.507v-4.3h.336v1.688a1.328,1.328,0,0,1,1.082-.58,1.655,1.655,0,0,1,0,3.268,1.328,1.328,0,0,1-1.082-.575v.5h-.336Zm1.362-.224c.693,0,1.089-.573,1.089-1.329s-.4-1.333-1.089-1.333a1.265,1.265,0,0,0-1.026.567v1.539A1.256,1.256,0,0,0,7534.94,1986.283Z",
    transform: "translate(-7533.578 -1982.209)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75182",
    "data-name": "Path 75182",
    d: "M7638.023,2024.771a.778.778,0,0,0,.272.051c.2,0,.345-.084.468-.38l.247-.554-1.315-3.139h.375l1.131,2.719,1.124-2.719h.379l-1.613,3.8a.823.823,0,0,1-.8.58,1.362,1.362,0,0,1-.332-.046Z",
    transform: "translate(-7634.493 -2019.564)",
    fill: "#aaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "xiden-logo_00000174568089181403304100000018281689574631230376_",
    transform: "translate(8.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "x-letter_00000105421784836811327690000008376457537074983603_",
    d: "M8065.146,2121.969l-1.745,2.152-1.724-2.152h-1.208v.009l2.349,2.907-2.349,2.92v.009h1.2l1.736-2.156,1.758,2.156h1.2v-.009l-2.357-2.92,2.357-2.907v-.009Z",
    transform: "translate(-8060.469 -2121.969)",
    fill: "#2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i-letter_00000065764436431282422630000010294948568827230399_",
    d: "M8308.906,2121.969l-.945,1.094v4.742l.945-1.311Z",
    transform: "translate(-8300.349 -2121.969)",
    fill: "#2af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d-letter_00000055686020966473341400000005003750546758453438_",
    transform: "translate(10.643 0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11077",
    "data-name": "Group 11077",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_00000075847705448462605020000011716597476518601650_",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5_00000136387294239324521150000009857113729928097952_",
    d: "M8126,1933.254a2.354,2.354,0,0,0,.907-.172,2.176,2.176,0,0,0,.715-.466,2.159,2.159,0,0,0,.468-2.373,2.02,2.02,0,0,0-.472-.69,2.263,2.263,0,0,0-.72-.467,2.329,2.329,0,0,0-.9-.17h-1.208l-.945-.749h2.26a3.243,3.243,0,0,1,2.217.859,3.013,3.013,0,0,1,.671.928,2.66,2.66,0,0,1,.247,1.134,2.734,2.734,0,0,1-.238,1.135,2.848,2.848,0,0,1-.66.923,3.087,3.087,0,0,1-.991.625,3.276,3.276,0,0,1-1.247.232h-1.315l-.945-.748Z",
    transform: "translate(-8123.844 -1928.167)",
    fill: "#2af",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "e-letter_00000121998022003065648680000001868633067249885113_",
    d: "M8650.591,2128l-.911.819h3.435l.787-.819Zm0-2.585-.911.821h3.435l.787-.821Zm0-2.406-.911.819h3.435l.787-.819Z",
    transform: "translate(-8631.556 -2122.978)",
    fill: "#2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n-letter_00000003784421853792909850000011183758703580812429_",
    d: "M8873.648,2121.969v5.946h.89v-3.685l3.323,3.685h1.238Zm5.451,0-.944,1.094v2.619l.944-1.311Z",
    transform: "translate(-8848.631 -2121.969)",
    fill: "#2af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11079",
    "data-name": "Group 11079",
    transform: "translate(129.157 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75183",
    "data-name": "Path 75183",
    d: "M8302.847,957.335h-6.69s-1.361-.016-1.953-.016c-1.076,0-1.809-.6-1.809-2.11V935.99h-4.949v19.624c0,4.131,2.4,6.2,5.35,6.2.067,0,.136,0,.2-.007h9.848Z",
    transform: "translate(-8217.313 -935.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75184",
    "data-name": "Path 75184",
    d: "M6675.384,930a13.084,13.084,0,0,0-12.192,17.859l4.468-7.747a8.28,8.28,0,1,1,.421,6.9l-2.651,4.59a13.095,13.095,0,1,0,9.954-21.6Z",
    transform: "translate(-6642.15 -930)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75185",
    "data-name": "Path 75185",
    d: "M7449.154,930a13.085,13.085,0,0,0-12.2,17.859l4.469-7.747a8.285,8.285,0,1,1,.425,6.9l-2.651,4.59a13.094,13.094,0,1,0,9.954-21.6Z",
    transform: "translate(-7392.111 -930)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75186",
    "data-name": "Path 75186",
    d: "M6023.32,947.14c-.758,1.83-2.636,2.73-5.413,2.73h-5.385v-9.554h5.385a6.8,6.8,0,0,1,4.274,1.168l2.319-4.017a12.473,12.473,0,0,0-6.336-1.468h-10.585v25.822h4.943v-7.6h5.643c6.494,0,10.22-3.431,10.22-9.333a9.332,9.332,0,0,0-1.094-4.627Z",
    transform: "translate(-6007.579 -935.816)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11080",
    "data-name": "Group 11080",
    transform: "translate(0 0.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75187",
    "data-name": "Path 75187",
    d: "M4018.9,941.316v21.505h-4.943V941.316h-7.226V937h19.356v4.316Z",
    transform: "translate(-3939.124 -937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75188",
    "data-name": "Path 75188",
    d: "M1830.026,958.438s-1.365-.016-1.954-.016c-1.07,0-1.655-.717-2.165-2.213l-3.928-9.761,8.271-9.457h-5.755l-10.552,11.931V936.99H1809v25.822h4.943v-7.177l4.29-4.906,2.35,5.885c1.678,4.158,2.754,6.2,5.706,6.2.069,0,.138,0,.207-.007h4.585v-4.367Z",
    transform: "translate(-1809.001 -936.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75189",
    "data-name": "Path 75189",
    d: "M4642.777,941.567c.613,0,2.037-.016,2.037-.016h6.4V937h-9.492c-.074,0-.146-.007-.219-.007-3.077,0-5.577,2.153-5.577,6.46v19.361h15.288v-4.576H4640.89v-5.662h8.213V948h-8.213v-4.124C4640.894,942.3,4641.662,941.567,4642.777,941.567Z",
    transform: "translate(-4548.967 -936.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75190",
    "data-name": "Path 75190",
    d: "M2548.066,945.89a9.182,9.182,0,0,0-1.115-4.624l-4.016,6.957h0c-.771,1.773-2.611,2.647-5.345,2.647h-5.829v-9.554h5.829a6.724,6.724,0,0,1,4.258,1.169l2.3-3.986a13.012,13.012,0,0,0-6.558-1.5h-10.771v25.822h4.942v-7.6h5.829a7.446,7.446,0,0,0,.922-.037l4.464,7.636h5.643l-5.68-8.558C2546.258,952.862,2548.066,949.948,2548.066,945.89Z",
    transform: "translate(-2504.737 -937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75191",
    "data-name": "Path 75191",
    d: "M5143.9,945.89a9.194,9.194,0,0,0-1.112-4.624l-4.018,6.957h0c-.772,1.773-2.613,2.647-5.344,2.647h-5.831v-9.554h5.831a6.721,6.721,0,0,1,4.255,1.169l2.3-3.986a13.011,13.011,0,0,0-6.557-1.5h-10.771v25.822h4.941v-7.6h5.831a7.454,7.454,0,0,0,.921-.037l4.462,7.636h5.645l-5.681-8.558C5142.092,952.862,5143.9,949.948,5143.9,945.89Z",
    transform: "translate(-5020.718 -937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75192",
    "data-name": "Path 75192",
    d: "M3246.132,951.872l.009.021h-7.067l3.551-9.407,1.778,4.757,2.949-5.109-2.034-5.143h-5.128l-10.329,25.822h5.091l2.52-6.677h10.256l2.5,6.677h5.312l-6.392-16.154Z",
    transform: "translate(-3186.151 -936.99)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXidenLogo);
export default __webpack_public_path__ + "static/media/xiden-logo.6f30f701edc2a611e423cd4357855b73.svg";
export { ForwardRef as ReactComponent };